import styled from '@emotion/styled'

const Error = styled.span`
  color: ${({ theme }) => theme.colors.red};
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 500;
`

const Label = styled.label`
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 500;
`

const StyledInput = styled.input`
  border-style: solid;
  border-width: 1px;
  border-color: ${({ error, theme }) =>
    error ? theme.colors.red : theme.colors.lightGray};
  border-radius: 0.125rem;
  font-family: -inter -u-i, -apple-system, -blink-mac-system-font, -segoe -u-i,
    -roboto, -helvetica, -arial, sans-serif;
  padding: 0.5rem;
  width: 100%;
  outline: 0;
`

const Input = (props) => {
  const inputProps = (({ className, error, label, ...o }) => o)(props)
  return (
    <div className={props.className}>
      {props.label && (
        <Label className="mb2" htmlFor={props.name}>
          {props.label}
        </Label>
      )}
      {props.label && props.error && (
        <Error className="mb2">{` ${props.error}`}</Error>
      )}
      <StyledInput {...inputProps} />
      {!props.label && props.error && (
        <Error className="mb2">{` ${props.error}`}</Error>
      )}
    </div>
  )
}

export default Input
